(function () {
  const root = document.querySelector('[data-ff-chat]');
  if (!root) return;

  const launcher = root.querySelector('.ff-chat__launcher');
  const panel = root.querySelector('.ff-chat__panel');
  const thread = root.querySelector('[data-ff-chat-thread]');
  const form = root.querySelector('[data-ff-chat-form]');
  const input = root.querySelector('.ff-chat__input');
  const lookupTemplate = root.querySelector('[data-ff-chat-order-lookup-template]');
  const ordersJsonEl = root.querySelector('[data-ff-chat-orders-json]');

  const loggedIn = root.dataset.loggedIn === 'true';
  const ordersUrl = root.dataset.ordersUrl || '/pages/my-orders';
  const loginUrl = root.dataset.loginUrl || '/customer_authentication/login';
  const supportEmail = root.dataset.supportEmail || 'info@41foods.com';

  let bootstrapped = false;
  let orders = [];

  if (ordersJsonEl) {
    try {
      orders = JSON.parse(ordersJsonEl.textContent || '[]');
    } catch (e) {
      orders = [];
    }
  }

  function normalizeOrderNumber(value) {
    return String(value || '')
      .trim()
      .replace(/^#+/, '')
      .replace(/\s+/g, '');
  }

  function openPanel() {
    panel.hidden = false;
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    if (!bootstrapped) {
      bootstrapChat();
      bootstrapped = true;
    }
    input.focus({ preventScroll: true });
  }

  function closePanel() {
    panel.hidden = true;
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
  }

  function scrollThread() {
    thread.scrollTop = thread.scrollHeight;
  }

  function addBubble(text, role) {
    const bubble = document.createElement('div');
    bubble.className = 'ff-chat__bubble ff-chat__bubble--' + role;
    bubble.textContent = text;
    thread.appendChild(bubble);
    scrollThread();
  }

  function renderOrderCard(order) {
    const card = document.createElement('article');
    card.className = 'ff-chat__order';
    card.dataset.orderName = order.name;

    const itemsHtml = (order.items || [])
      .map(function (item) {
        const img = item.image
          ? '<img src="' + item.image + '" alt="" width="36" height="36" loading="lazy">'
          : '';
        return '<li>' + img + '<span>' + item.quantity + ' × ' + item.title + '</span></li>';
      })
      .join('');

    let trackingHtml = '';
    if (order.tracking && order.tracking.length > 0) {
      trackingHtml = order.tracking
        .map(function (track) {
          const label =
            'Track shipment' +
            (track.company ? ' (' + track.company + ')' : '') +
            (track.number ? ' · ' + track.number : '');
          return (
            '<a class="ff-chat__track-link" href="' +
            track.url +
            '" target="_blank" rel="noopener noreferrer">' +
            label +
            '</a>'
          );
        })
        .join('');
    } else {
      trackingHtml = '<p class="ff-chat__order-note">Tracking will appear here once your order ships.</p>';
    }

    card.innerHTML =
      '<div class="ff-chat__order-head">' +
      '<div><p class="ff-chat__order-name">' +
      order.name +
      '</p><p class="ff-chat__order-date">' +
      order.date +
      '</p></div>' +
      '<p class="ff-chat__order-total">' +
      order.total +
      '</p></div>' +
      '<div class="ff-chat__order-badges">' +
      '<span class="ff-chat__badge">Payment: ' +
      order.paymentStatus +
      '</span>' +
      '<span class="ff-chat__badge ff-chat__badge--fulfillment">Fulfillment: ' +
      order.fulfillmentStatus +
      '</span></div>' +
      (itemsHtml ? '<ul class="ff-chat__order-items">' + itemsHtml + '</ul>' : '') +
      trackingHtml;

    return card;
  }

  function appendOrdersBlock(orderList, footerHtml) {
    const wrap = document.createElement('div');
    wrap.className = 'ff-chat__orders-block';
    orderList.forEach(function (order) {
      wrap.appendChild(renderOrderCard(order));
    });
    if (footerHtml) {
      const footer = document.createElement('div');
      footer.className = 'ff-chat__orders-footer';
      footer.innerHTML = footerHtml;
      wrap.appendChild(footer);
    }
    thread.appendChild(wrap);
    scrollThread();
  }

  function showRecentOrders(limit) {
    if (!loggedIn) {
      addBubble('Sign in to see your recent orders and live status.', 'bot');
      showOrderLookup();
      return;
    }

    if (!orders.length) {
      addBubble('You have not placed any orders yet. Start shopping and your order status will show here.', 'bot');
      const link = document.createElement('a');
      link.className = 'ff-chat__all-orders';
      link.href = '/collections/all';
      link.textContent = 'Browse products';
      thread.appendChild(link);
      scrollThread();
      return;
    }

    const recent = orders.slice(0, limit || 3);
    addBubble('Do you need any help with these orders?', 'bot');
    appendOrdersBlock(
      recent,
      '<button type="button" class="ff-chat__chip ff-chat__chip--inline" data-ff-chat-prompt="lookup-order">Track a different order #</button>'
    );
    bindDynamicPrompts();
  }

  function findOrderByNumber(rawNumber) {
    const normalized = normalizeOrderNumber(rawNumber);
    if (!normalized) return null;
    return (
      orders.find(function (order) {
        return normalizeOrderNumber(order.number) === normalized || normalizeOrderNumber(order.name) === normalized;
      }) || null
    );
  }

  function lookupOrder(rawNumber, fromUser) {
    const display = rawNumber.trim() || 'order lookup';
    if (fromUser) addBubble(display.indexOf('#') === 0 ? display : '#' + normalizeOrderNumber(display), 'user');

    if (!loggedIn) {
      addBubble('Please sign in to track orders on your account.', 'bot');
      showOrderLookup(normalizeOrderNumber(rawNumber));
      return;
    }

    const match = findOrderByNumber(rawNumber);
    if (!match) {
      addBubble('We could not find order #' + normalizeOrderNumber(rawNumber) + ' on your account.', 'bot');
      addBubble('Check the number from your confirmation email, or contact us at ' + supportEmail + '.', 'bot');
      showOrderLookup();
      return;
    }

    addBubble('Here is the status for ' + match.name + ':', 'bot');
    appendOrdersBlock([match], '');
  }

  function showOrderLookup(prefill) {
    if (!lookupTemplate) return;

    const existing = thread.querySelector('[data-ff-chat-lookup-form]');
    if (existing) {
      if (prefill) existing.querySelector('[name="order_number"]').value = prefill;
      existing.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }

    addBubble('Enter your order number to track status:', 'bot');
    const node = lookupTemplate.content.cloneNode(true);
    thread.appendChild(node);

    const lookupForm = thread.querySelector('[data-ff-chat-lookup-form]');
    const orderInput = lookupForm.querySelector('[name="order_number"]');
    if (prefill) orderInput.value = prefill;

    lookupForm.addEventListener('submit', function (event) {
      event.preventDefault();
      const value = orderInput.value.trim();
      if (!loggedIn) {
        if (value) sessionStorage.setItem('ff_chat_pending_order', normalizeOrderNumber(value));
        addBubble('Sign in to track order #' + normalizeOrderNumber(value) + '.', 'bot');
        const link = document.createElement('a');
        link.className = 'ff-chat__all-orders';
        link.href = loginUrl;
        link.textContent = 'Sign in to continue';
        thread.appendChild(link);
        scrollThread();
        return;
      }
      lookupOrder(value, false);
    });

    scrollThread();
    orderInput.focus({ preventScroll: true });
  }

  function bootstrapChat() {
    if (loggedIn && orders.length > 0) {
      showRecentOrders(3);
      return;
    }

    if (loggedIn) {
      addBubble('Hi! How can we help with your 41foods order today?', 'bot');
      return;
    }

    addBubble('Hi! Track your order by number or sign in to see recent orders.', 'bot');
  }

  function bindDynamicPrompts() {
    thread.querySelectorAll('[data-ff-chat-prompt="lookup-order"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showOrderLookup();
      });
    });
  }

  function replyToMessage(text) {
    const trimmed = text.trim();
    if (!trimmed) return;

    const normalized = trimmed.toLowerCase();
    const orderMatch = trimmed.match(/#?\s*(\d[\d-]*)/);

    if (/^#?\s*\d[\d-]*$/.test(trimmed.replace(/\s/g, '')) || (/order/.test(normalized) && orderMatch)) {
      lookupOrder(orderMatch ? orderMatch[1] : trimmed, true);
      return;
    }

    addBubble(trimmed, 'user');

    if (/recent|my orders|track my order|order status/.test(normalized)) {
      showRecentOrders(3);
      return;
    }

    if (/track|status|where|ship|delivery/.test(normalized)) {
      if (loggedIn && orders.length) {
        showRecentOrders(3);
      } else {
        showOrderLookup();
      }
      return;
    }

    if (/ship|deliver|courier|how long/.test(normalized)) {
      addBubble(
        'We pack fresh and dispatch quickly. Most orders ship within 1–2 business days. Use Track by order # for live status.',
        'bot'
      );
      return;
    }

    if (/return|refund|exchange/.test(normalized)) {
      addBubble('For returns or refunds, email ' + supportEmail + ' with your order number.', 'bot');
      return;
    }

    if (/bulk|wholesale|business/.test(normalized)) {
      addBubble('For bulk orders, visit our Bulk page or email ' + supportEmail + '.', 'bot');
      return;
    }

    if (/human|agent|person|support|help/.test(normalized)) {
      addBubble('Email us at ' + supportEmail + ' and our team will reply shortly.', 'bot');
      return;
    }

    addBubble('Try Track by order # or ask about your recent orders.', 'bot');
  }

  launcher.addEventListener('click', function () {
    if (panel.hidden) openPanel();
    else closePanel();
  });

  document.querySelectorAll('[data-ff-chat-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openPanel();
    });
  });

  root.querySelectorAll('[data-ff-chat-action="minimize"]').forEach(function (btn) {
    btn.addEventListener('click', closePanel);
  });

  root.querySelectorAll('[data-ff-chat-action="expand"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      panel.classList.toggle('is-expanded');
    });
  });

  root.querySelectorAll('[data-ff-chat-prompt="lookup-order"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (panel.hidden) openPanel();
      showOrderLookup();
    });
  });

  root.querySelectorAll('[data-ff-chat-prompt="recent-orders"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (panel.hidden) openPanel();
      addBubble('Show my recent orders', 'user');
      showRecentOrders(3);
    });
  });

  root.querySelectorAll('[data-ff-chat-action="support"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.location.href = 'mailto:' + supportEmail;
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const value = input.value;
    input.value = '';
    replyToMessage(value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });

  const pendingLookup = sessionStorage.getItem('ff_chat_pending_order');
  if (pendingLookup) {
    sessionStorage.removeItem('ff_chat_pending_order');
    if (loggedIn) {
      launcher.click();
      setTimeout(function () {
        lookupOrder(pendingLookup, true);
      }, 100);
    }
  }
})();
